export const FormatValue = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value ? value : 0);
}

export const onKeyPressHandler = (e, onClick) => {
    const enterOrSpace =
        e.key === "Enter" ||
        e.key === " " ||
        e.key === "Spacebar" ||
        e.which === 13 ||
        e.which === 32;

    if (enterOrSpace) {
        e.preventDefault();
        onClick(e);
    }
}